import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {resolveApiBase} from '../core/api-base';

export interface StatusResponse {
  status: string;
  // Returned by /confirm (success). redirect_url is the application's return URL:
  // the Client's configured ReturnUrl if set, else the origin of its first
  // CallbackUrl. The SPA sends the user there so the app re-initiates a fresh
  // OAuth login. client_id is the fallback target (/login?client_id) when no
  // redirect_url is resolvable. Both derived from the token, so the reset link
  // carries neither.
  redirect_url?: string;
  app_name?: string;
  client_id?: string;
}

/**
 * Wraps the backend/password-reset Lambda's two anonymous endpoints (Story 23.1).
 * The /request endpoint always returns {status:"ok"} regardless of account
 * existence (anti-enumeration) — the ForgotPasswordComponent mirrors that by
 * always showing a "check your email" screen.
 */
@Injectable({providedIn: 'root'})
export class PasswordResetService {
  private readonly http = inject(HttpClient);

  requestReset(email: string, clientId: string): Observable<StatusResponse> {
    return this.http.post<StatusResponse>(
      `${resolveApiBase()}/password-reset/request`,
      {email, client_id: clientId}
    );
  }

  confirmReset(token: string, newPassword: string): Observable<StatusResponse> {
    return this.http.post<StatusResponse>(
      `${resolveApiBase()}/password-reset/confirm`,
      {token, new_password: newPassword}
    );
  }
}
